import { render, staticRenderFns } from "./TeamDefinitionList.vue?vue&type=template&id=07a591e5&"
import script from "./TeamDefinitionList.vue?vue&type=script&lang=js&"
export * from "./TeamDefinitionList.vue?vue&type=script&lang=js&"
import style0 from "./TeamDefinitionList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports